import { useClassName } from "@contember/react-utils";
import { createElement } from "react";
import { toViewClass } from "../../utils/toViewClass.js";
const EditorNonEditable = ({ inline, ...props }) => createElement(inline ? "span" : "div", {
  ...props,
  contentEditable: false,
  className: useClassName("editorNonEditable", [toViewClass("inline", inline), props.className])
});
EditorNonEditable.displayName = "EditorNonEditable";
export {
  EditorNonEditable
};
//# sourceMappingURL=EditorNonEditable.js.map
